export const FINANCING_ENDING_RECIPIENT_SOURCE = {
  OPERATOR: 'OPERATOR',
  CONTACT_PERSON: 'CONTACT_PERSON',
  CUSTOMER: 'CUSTOMER',
} as const;
